import MuiMenu, { MenuProps as MuiMenuProps } from '@mui/material/Menu';

export type MenuProps = MuiMenuProps;

export const Menu = (props: MenuProps) => {
  return <MuiMenu {...props} />;
};
